import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryOverview() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            浏览资讯分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按您感兴趣的主题浏览，快速找到所需内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-accent-300/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2 font-heading">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center text-sm text-accent-600 font-medium">
                浏览文章 <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}